import { combineReducers } from 'redux';

import filtersReducers from '../components/Filter/store/reducer';
import paginationReducers from '../components/Pagination/store/reducer';
import dateFilterReducers from '../components/LayoutRoute/store/reducer';
import dashboardReducer from '../pages/Dashboard/store/reducer';
import loginReducer from '../pages/Login/store/reducer';
import operationalHistoryReducer from '../pages/OperationalHistory/store/reducer';
import serviceOrderReducer from '../components/ServiceOrder/store/reducer';
import activitiesReducer from '../pages/ActivitiesRegistration/store/reducer';
import sessionsReducer from '../pages/SessionsRegistration/store/reducer';
import profileReducer from '../pages/Profile/store/reducer';
import cashFlowReducer from '../pages/CashFlow/store/reducer';
import transactionsReducer from '../pages/Transactions/store/reducer';
import provisionalReceiptReducer from '../pages/ProvisionalReceipt/store/reducer';
import servicesReducer from '../pages/Services/store/reducer';
import employeesListReducers from '../pages/EmployeesList/store/reducer';
import employeesRegistrationReducers from '../pages/EmployeesRegistration/store/reducer';
import priceTableReducer from '../pages/PriceTable/store/reducer';
import businessInfoReducer from '../pages/BusinessInfo/store/reducer';
import businessInfoRegistrationReducer from '../pages/BusinessInfoRegistration/store/reducer';
import clientListReducer from '../pages/ClientList/store/reducer';
import clientInvoicesReducer from '../pages/ClientInvoices/store/reducer';
import listClientsReducer from '../pages/ListClients/store/reducer';
import clientRegistrationReducer from '../pages/ClientRegistration/store/reducer';
import accountsReducer from '../pages/Accounts/store/reducer';
import categoriesReducer from '../pages/Categories/store/reducer';
import costCentersReducer from '../pages/CostCenters/store/reducer';
import paymentMethodsReducer from '../pages/PaymentMethods/store/reducer';
import provisionalReceiptConfigReducer from '../pages/ProvisionalReceiptConfig/store/reducer';
import provisionalReceiptProductConfigReducer from '../pages/ProvisionalReceiptProductConfig/store/reducer';
import notificationsReducer from '../pages/NotificationsList/store/reducer';
import notificationsConfigReducer from '../pages/NotificationsConfig/store/reducer';
import operationalReducer from '../pages/Operational/store/reducer';
import typePermissionReducer from './permission/reducer';
import onboardingReducer from '../components/Onboarding/store/reducer';
import comissionsReducer from '../pages/Comissions/store/reducer';
import comissionedListReducer from '../pages/ComissionedList/store/reducer';
import comissionedPayrollsReducer from '../pages/ComissionedPayrolls/store/reducer';
import comissionedRegistrationReducer from '../pages/ComissionedRegistration/store/reducer';
import comissionedPayrollListReducer from '../pages/ComissionedPayrollList/store/reducer';
import comissionedPayrollRegistrationReducer from '../pages/ComissionedPayrollRegistration/store/reducer';
import comissionedPayrollSheetReducer from '../pages/ComissionedPayrollSheet/store/reducer';
import vehicleDamageReducer from '../pages/VehicleDamage/store/reducer';
import productsReducer from '../pages/Products/store/reducer';
import productsRegistrationReducer from '../pages/ProductsRegistration/store/reducer';
import productsSellRegistrationReducer from '../pages/ProductsSellRegistration/store/reducer';
import productsUseAndSellRegistrationReducer from '../pages/ProductsUseAndSellRegistration/store/reducer';
import productsCategoriesReducer from '../pages/ProductsCategories/store/reducer';
import productsBrandsReducer from '../pages/ProductsBrands/store/reducer';
import storageHistoryReducer from '../pages/StorageHistory/store/reducer';
import sellOrdersReducer from '../pages/SellOrders/store/reducer';
import supplierRegistrationReducer from '../pages/SupplierRegistration/store/reducer';
import supplierListReducer from '../pages/SupplierList/store/reducer';
import modalDrawerSwitcherReducer from '../components/ModalDrawerSwitcher/store/reducer';
import schedulingReducer from '../pages/Scheduling/store/reducer';
import schedulingConfigurationsReducer from '../pages/SchedulingConfigurations/store/reducer';
import schedulingOthersReducer from '../components/SchedulingOthersRegistration/store/reducer';
import schedulingServicesReducer from '../components/SchedulingServicesRegistration/store/reducer';
import advancedConfigsReducer from '../pages/AdvancedConfigurations/store/reducer';
import openApiReducer from '../pages/OpenAPI/store/reducer';
import openApiRegistrationReducer from '../pages/OpenAPIRegistration/store/reducer';
import selfServiceReducer from '../pages/SelfService/store/reducer';

export default combineReducers({
  accounts: accountsReducer,
  activities: activitiesReducer,
  businessInfo: businessInfoReducer,
  businessInfoRegistration: businessInfoRegistrationReducer,
  cashFlow: cashFlowReducer,
  categories: categoriesReducer,
  clientList: clientListReducer,
  clientInvoices: clientInvoicesReducer,
  clientRegistration: clientRegistrationReducer,
  listClients: listClientsReducer,
  costCenters: costCentersReducer,
  dateFilter: dateFilterReducers,
  dashboard: dashboardReducer,
  employeesList: employeesListReducers,
  employeesRegistration: employeesRegistrationReducers,
  filters: filtersReducers,
  login: loginReducer,
  operationalHistory: operationalHistoryReducer,
  pagination: paginationReducers,
  paymentMethods: paymentMethodsReducer,
  priceTable: priceTableReducer,
  profile: profileReducer,
  provisionalReceipt: provisionalReceiptReducer,
  serviceOrder: serviceOrderReducer,
  services: servicesReducer,
  sessions: sessionsReducer,
  transactions: transactionsReducer,
  notifications: notificationsReducer,
  notificationsConfig: notificationsConfigReducer,
  provisionalReceiptConfig: provisionalReceiptConfigReducer,
  provisionalReceiptProductConfig: provisionalReceiptProductConfigReducer,
  operational: operationalReducer,
  typePermission: typePermissionReducer,
  onboarding: onboardingReducer,
  comissions: comissionsReducer,
  comissionedList:comissionedListReducer,
  comissionedPayrolls: comissionedPayrollsReducer,
  comissionedRegistration: comissionedRegistrationReducer,
  comissionedPayrollList: comissionedPayrollListReducer,
  comissionedPayrollRegistration: comissionedPayrollRegistrationReducer,
  comissionedPayrollSheet: comissionedPayrollSheetReducer,
  vehicleDamage: vehicleDamageReducer,
  products: productsReducer,
  productsRegistration: productsRegistrationReducer,
  productsSellRegistration: productsSellRegistrationReducer,
  productsUseAndSellRegistration: productsUseAndSellRegistrationReducer,
  productsCategories: productsCategoriesReducer,
  productsBrands: productsBrandsReducer,
  storageHistory: storageHistoryReducer,
  sellOrders: sellOrdersReducer,
  supplierRegistration: supplierRegistrationReducer,
  supplierList: supplierListReducer,
  modalDrawerSwitcher: modalDrawerSwitcherReducer,
  scheduling: schedulingReducer,
  schedulingConfigurations: schedulingConfigurationsReducer,
  schedulingOthers: schedulingOthersReducer,
  schedulingServices: schedulingServicesReducer,
  advancedConfigs: advancedConfigsReducer,
  openApi: openApiReducer,
  openApiRegistration: openApiRegistrationReducer,
  selfService: selfServiceReducer
});